module.exports = __webpack_public_path__ + "static/media/balance2.7bff8a18.png";